module.exports = __webpack_public_path__ + "img/ticket.3dfc09ee.svg";